<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import { contacts } from "@js/company_details.ts";

export default {
    name: "PrivacyPolicyPage",
    components: { Breadcrumbs },
    setup() {
        return {
            contacts,
        };
    },
};
</script>

<template>
    <div class="container mx-auto mt-5 mb-10">
        <Breadcrumbs class="mb-2" />

        <h1 class="text-2xl md:text-3xl font-semibold">
            Политика конфиденциальности
        </h1>

        <hr class="mt-5 mb-8" />

        <div class="space-y-10 text-sm md:text-base leading-7 text-[#111111]">
            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    Политика в отношении обработки персональных данных
                </h2>

                <p class="mb-3">
                    Настоящая политика обработки персональных данных составлена в соответствии с требованиями
                    Федерального закона от 27.07.2006 №152-ФЗ «О персональных данных» и определяет порядок обработки
                    персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые
                    Оператором.
                </p>

                <p class="mb-3">
                    Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и
                    свобод человека и гражданина при обработке его персональных данных, в том числе защиту права на
                    неприкосновенность частной жизни, личную и семейную тайну.
                </p>

                <p>
                    Настоящая Политика применяется ко всей информации, которую сайт
                    <strong> x-devs.ru </strong>
                    может получить о посетителях сайта.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    1. Основные понятия
                </h2>

                <p class="mb-2">
                    <strong>Персональные данные</strong> — любая информация, относящаяся прямо или косвенно к
                    определенному или определяемому пользователю сайта.
                </p>
                <p class="mb-2">
                    <strong>Обработка персональных данных</strong> — любое действие или совокупность действий,
                    совершаемых с персональными данными, включая сбор, запись, систематизацию, накопление, хранение,
                    уточнение, использование, обезличивание, блокирование, удаление и уничтожение.
                </p>
                <p class="mb-2">
                    <strong>Оператор</strong> — лицо, самостоятельно организующее и осуществляющее обработку
                    персональных данных, а также определяющее цели обработки персональных данных и состав обрабатываемых
                    данных.
                </p>
                <p>
                    <strong>Пользователь</strong> — любой посетитель сайта x-devs.ru.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    2. Какие персональные данные могут обрабатываться
                </h2>

                <p class="mb-2">Оператор может обрабатывать следующие персональные данные Пользователя:</p>

                <ul class="list-disc pl-5 space-y-1">
                    <li>имя;</li>
                    <li>номер телефона;</li>
                    <li>адрес электронной почты;</li>
                    <li>иная информация, которую Пользователь добровольно указывает в формах на сайте;</li>
                    <li>
                        обезличенные данные о посетителях, собираемые с помощью файлов cookie, систем аналитики и
                        статистики.
                    </li>
                </ul>

                <p class="mt-3">
                    Оператор не осуществляет обработку специальных категорий персональных данных, касающихся расовой,
                    национальной принадлежности, политических взглядов, религиозных или философских убеждений,
                    состояния здоровья или интимной жизни, если иное прямо не предусмотрено законодательством.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    3. Цели обработки персональных данных
                </h2>

                <p class="mb-2">Персональные данные Пользователя обрабатываются в следующих целях:</p>

                <ul class="list-disc pl-5 space-y-1">
                    <li>обработка обращений, заявок и запросов, поступающих через формы сайта;</li>
                    <li>обратная связь с Пользователем;</li>
                    <li>предоставление информации об услугах компании;</li>
                    <li>улучшение работы сайта и его функциональности;</li>
                    <li>анализ поведения посетителей и повышение качества сервиса;</li>
                    <li>исполнение требований законодательства Российской Федерации.</li>
                </ul>

                <p class="mt-3">
                    Пользователь также может дать согласие на получение информационных сообщений. Пользователь вправе в
                    любой момент отказаться от таких сообщений, направив уведомление на адрес:
                    <strong> {{ contacts.info_mail }} </strong>.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    4. Правовые основания обработки персональных данных
                </h2>

                <p class="mb-2">Правовыми основаниями обработки персональных данных являются:</p>

                <ul class="list-disc pl-5 space-y-1">
                    <li>Федеральный закон от 27.07.2006 №152-ФЗ «О персональных данных»;</li>
                    <li>иные нормативные правовые акты Российской Федерации;</li>
                    <li>согласие Пользователя на обработку его персональных данных;</li>
                    <li>добровольное заполнение Пользователем форм на сайте x-devs.ru.</li>
                </ul>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    5. Порядок обработки и хранения персональных данных
                </h2>

                <p class="mb-3">
                    Обработка персональных данных осуществляется с соблюдением принципов законности, справедливости,
                    ограничения обработки достижением конкретных целей, недопущения избыточности и обеспечения
                    актуальности данных.
                </p>

                <p class="mb-3">
                    Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных
                    данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования,
                    копирования, предоставления, распространения, а также от иных неправомерных действий.
                </p>

                <p class="mb-3">
                    Персональные данные хранятся не дольше, чем этого требуют цели обработки, если иной срок хранения
                    не установлен законодательством Российской Федерации.
                </p>

                <p>
                    Условием прекращения обработки персональных данных может быть достижение целей обработки, отзыв
                    согласия Пользователем, а также выявление неправомерной обработки персональных данных.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    6. Передача персональных данных третьим лицам
                </h2>

                <p class="mb-3">
                    Персональные данные Пользователя не передаются третьим лицам, за исключением случаев,
                    предусмотренных законодательством Российской Федерации, либо случаев, когда такая передача
                    необходима для исполнения запроса Пользователя или функционирования сайта и связанных сервисов.
                </p>

                <p>
                    Сторонние сервисы, используемые на сайте, включая сервисы веб-аналитики, могут осуществлять сбор
                    обезличенных технических данных в соответствии со своими правилами и политиками конфиденциальности.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    7. Использование cookie и технических данных
                </h2>

                <p class="mb-3">
                    При посещении сайта могут автоматически собираться обезличенные технические данные, включая IP-адрес,
                    сведения о браузере, времени посещения, источнике перехода, типе устройства, операционной системе и
                    иные данные, необходимые для корректной работы сайта и аналитики.
                </p>

                <p>
                    Сайт может использовать файлы cookie для сохранения пользовательских настроек, аналитики и
                    улучшения качества работы сайта. Пользователь может отключить cookie в настройках своего браузера,
                    однако это может повлиять на корректность работы отдельных функций сайта.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    8. Права пользователя
                </h2>

                <p class="mb-2">Пользователь имеет право:</p>

                <ul class="list-disc pl-5 space-y-1">
                    <li>получать сведения о своих персональных данных и порядке их обработки;</li>
                    <li>требовать уточнения, блокирования или уничтожения своих персональных данных;</li>
                    <li>отозвать согласие на обработку персональных данных;</li>
                    <li>обжаловать действия или бездействие Оператора в установленном законом порядке.</li>
                </ul>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    9. Актуализация, изменение и удаление персональных данных
                </h2>

                <p class="mb-3">
                    Пользователь может направить запрос на уточнение, изменение или удаление своих персональных данных,
                    а также на отзыв согласия на их обработку, направив обращение на электронную почту:
                    <strong> {{ contacts.info_mail }} </strong>.
                </p>

                <p>
                    Запрос должен позволять идентифицировать Пользователя и предмет обращения.
                </p>
            </section>

            <section>
                <h2 class="text-xl md:text-2xl mb-4 font-semibold">
                    10. Заключительные положения
                </h2>

                <p class="mb-3">
                    Оператор вправе вносить изменения в настоящую Политику без предварительного уведомления
                    Пользователя. Новая редакция Политики вступает в силу с момента ее размещения на сайте, если иное
                    не предусмотрено новой редакцией.
                </p>

                <p class="mb-3">
                    Актуальная версия Политики конфиденциальности всегда доступна на сайте x-devs.ru.
                </p>

                <p>
                    По всем вопросам, связанным с обработкой персональных данных, Пользователь может обратиться по
                    адресу электронной почты:
                    <strong> {{ contacts.info_mail }} </strong>.
                </p>
            </section>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
